import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="bg-gray-50 min-h-[70vh]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('about.title')}
          </h1>
          <p className="text-xl text-blue-600">
            {t('about.subtitle')}
          </p>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-xl shadow-md p-8 mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            {t('about.whatIsSpeedcubing.title')}
          </h2>
          <p className="text-gray-600 mb-6 leading-relaxed">
            {t('about.whatIsSpeedcubing.content')}
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            {t('about.ourCommunity.title')}
          </h2>
          <p className="text-gray-600 mb-6 leading-relaxed">
            {t('about.ourCommunity.content')}
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            {t('about.wca.title')}
          </h2>
          <p className="text-gray-600 leading-relaxed">
            {t('about.wca.content')}
          </p>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          <div className="bg-white rounded-xl shadow-md p-6 text-center">
            <div className="text-3xl font-bold text-blue-600 mb-2">17</div>
            <div className="text-sm text-gray-500">{t('about.stats.events')}</div>
          </div>
          <div className="bg-white rounded-xl shadow-md p-6 text-center">
            <div className="text-3xl font-bold text-orange-500 mb-2">3.13s</div>
            <div className="text-sm text-gray-500">{t('about.stats.worldRecord')}</div>
          </div>
          <div className="bg-white rounded-xl shadow-md p-6 text-center">
            <div className="text-3xl font-bold text-green-600 mb-2">150+</div>
            <div className="text-sm text-gray-500">{t('about.stats.countries')}</div>
          </div>
          <div className="bg-white rounded-xl shadow-md p-6 text-center">
            <div className="text-3xl font-bold text-purple-600 mb-2">200K+</div>
            <div className="text-sm text-gray-500">{t('about.stats.competitors')}</div>
          </div>
        </div>

        {/* Events Section */}
        <div className="bg-white rounded-xl shadow-md p-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-6">
            {t('about.events.title')}
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { name: '3x3x3', icon: '🟩' },
              { name: '2x2x2', icon: '🟧' },
              { name: '4x4x4', icon: '🟦' },
              { name: '5x5x5', icon: '🟪' },
              { name: '6x6x6', icon: '🟫' },
              { name: '7x7x7', icon: '⬛' },
              { name: '3x3x3 Blindfolded', icon: '🙈' },
              { name: '3x3x3 Fewest Moves', icon: '🧠' },
              { name: '3x3x3 One-Handed', icon: '✋' },
              { name: 'Clock', icon: '🕐' },
              { name: 'Megaminx', icon: '⬡' },
              { name: 'Pyraminx', icon: '🔺' },
              { name: 'Skewb', icon: '◇' },
              { name: 'Square-1', icon: '🔲' },
              { name: '4x4x4 Blindfolded', icon: '😶' },
              { name: '5x5x5 Blindfolded', icon: '🫣' },
              { name: '3x3x3 Multi-Blind', icon: '🎯' },
            ].map((event) => (
              <div key={event.name} className="flex items-center space-x-2 p-3 bg-gray-50 rounded-lg">
                <span className="text-xl">{event.icon}</span>
                <span className="text-gray-700 text-sm">{event.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
